import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from "react-toastify";
import { useGetBlogs } from "../../queries/blog";
import { useGetChallengeCategoriesList } from "../../queries/challenge";
import { useEffect, useState } from 'react';
import { ActionButton } from '../../components/Forms/ActionButton';
import { useGetAllUsers } from '../../queries/user';
import { useNavigate } from 'react-router-dom';
import { useHeader } from '../../context/HeaderContext';
import UserBlogListTable from './components/UserBlogListTable';

const UserBlogList = () => {

    const navigate = useNavigate();

    const { setHeaderTitle } = useHeader();

    useEffect(() => {
        setHeaderTitle('Blog Submissions');
        return () => {
          setHeaderTitle('');
        };
      }, [setHeaderTitle]);
    
    // const [selectedTab, setSelectedTab] = useState('user-blog-submission'); // ['blogs-list', 'user-blog-submission']

    const { data, isPending, isError, refetch } = useGetBlogs('user');
    console.log('user blogs: ', data);
    const { data: users, isPending: isUserPending } = useGetAllUsers(toast);
    const { data: challengeCategoryList, isPending: isChallengeCategoryPending } = useGetChallengeCategoriesList();

    const [filteredData, setFilteredData] = useState(!isPending && data);

    const [filters, setFilters] = useState({
        fromDate: '',
        toDate: '',
        status: '',
        category: '',
        proposedBy: '',
        title: '',
    });

    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setFilters((prev) => ({ ...prev, [name]: value }));
    };

    const handleReset = () => {
        setFilters({
            fromDate: '',
            toDate: '',
            status: '',
            category: '',
            proposedBy: '',
            title: '',
        });
        setFilteredData(Array.isArray(data) ? data : []);
    };

    const handleSearch = (e) => {
        e.preventDefault();
        let filtered = Array.isArray(data) ? data : [];
        if (filters.fromDate) {
            filtered = filtered.filter((blog) => new Date(blog.createdAt) >= new Date(filters.fromDate));
        }
        if (filters.toDate) {
            filtered = filtered.filter((blog) => new Date(blog.createdAt) <= new Date(filters.toDate));
        }
        if (filters.status) {
            filtered = filtered.filter((blog) => blog.status === filters.status);
        }
        if (filters.category) {
            filtered = filtered.filter((blog) => blog?.category?.name?.toLowerCase() === filters?.category?.toLowerCase());
        }
        if (filters.proposedBy) {
            filtered = filtered.filter((blog) =>
                blog?.createdByUser?._id === filters?.proposedBy
            );
        }
        if(filters.title) {
            filtered = filtered.filter((blog) =>
                blog.title.toLowerCase().includes(filters.title.toLowerCase())
            );
        }
        setFilteredData(filtered);
    }

    useEffect(() => {
        if (Array.isArray(data)) {
            setFilteredData(data);
        } else {
            setFilteredData([]);
        }
    }, [data]);

    if (isPending || isUserPending || isChallengeCategoryPending) {
        return (
            <div className="flex justify-center items-center w-full h-96">
                <h1 className="text-xl text-gray-400">Loading...</h1>
            </div>
        );
    }
    
    if (isError) {
        return (
            <div className="flex justify-center items-center w-full h-96">
                <h1 className="text-xl text-gray-400">Error fetching data!</h1>
            </div>
        );
    }
    
    return (
        <main className="flex flex-col text-base font-semibold text-gray-900 rounded-none">

            {/* Tabs */}
            {/* <div className='my-4 flex gap-2'>
                <button
                    className={`font-bold text-base flex-grow rounded-md py-2 border-2 ${selectedTab === 'blogs-list' ? 'bg-white' : 'bg-navBtn'} ${selectedTab === 'blogs-list' ? 'border-primary' : 'border-navBtn'}`}
                    onClick={() => {
                        setSelectedTab('blogs-list');
                        refetch('admin');
                    }}
                >
                    Blog List</button>
                <button
                    className={`font-bold text-base flex-grow rounded-md py-2 border-2 ${selectedTab === 'user-blog-submission' ? 'bg-white' : 'bg-navBtn'} ${selectedTab === 'user-blog-submission' ? 'border-primary' : 'border-navBtn'}`}
                    onClick={() => {
                        setSelectedTab('user-blog-submission');
                        refetch('user');
                    }}
                >
                    User Blog Submission</button>
            </div> */}

            {/* Filters */}
            <form
                className="flex flex-col pt-5 w-full bg-white rounded-md shadow-[0px_0px_25px_rgba(94,92,154,0.1)] "
                onSubmit={handleSearch}
            >
                <div className='flex items-center justify-between pr-5'>
                    <div className="flex gap-1.5 items-start my-auto text-base whitespace-nowrap ml-5">
                        <img
                            loading="lazy"
                            src="https://cdn.builder.io/api/v1/image/assets/TEMP/4dd39feef0ff4934d9e2e86b8c7285d5d7532aeb26adcdc1e878d021439e2681?placeholderIfAbsent=true&apiKey=d62bea31e5c5472d8bb4326e92b00478"
                            alt=""
                            className="object-contain shrink-0 w-5 aspect-square"
                        />
                        <span className="self-stretch">Filters</span>
                        <img
                            loading="lazy"
                            src="https://cdn.builder.io/api/v1/image/assets/TEMP/d18f51a0b2d597a302f55b77fc1071043eab5f274a1cc9e9b3fe3e2c97520a8c?placeholderIfAbsent=true&apiKey=d62bea31e5c5472d8bb4326e92b00478"
                            alt=""
                            className="object-contain shrink-0 aspect-square w-[18px]"
                        />
                    </div>
                </div>
                <div className="flex flex-wrap gap-4 p-5">
                    <div className='flex gap-3 w-full'>
                        <div className="flex-col w-full">
                            <label htmlFor="fromDate" className="gap-1 self-stretch w-full text-gray-900 text-base">
                                From Date
                            </label>
                            <div className="flex gap-2.5 items-center px-4 py-2.5 mt-2.5 w-full whitespace-nowrap bg-white rounded-md border border-solid border-navBtn text-slate-400">
                                <input
                                    type="date"
                                    name="fromDate"
                                    value={filters.fromDate}
                                    onChange={handleFilterChange}
                                // className="border border-gray-300 rounded-md px-2 py-1"
                                />
                            </div>
                        </div>
                        <div className="flex-col w-full">
                            <label htmlFor="toDate" className="gap-1 self-stretch w-full text-gray-900 text-base">
                                To Date
                            </label>
                            <div className="flex gap-2.5 items-center px-4 py-2.5 mt-2.5 w-full whitespace-nowrap bg-white rounded-md border border-solid border-navBtn text-slate-400">
                                <input
                                    type="date"
                                    name="toDate"
                                    value={filters.toDate}
                                    onChange={handleFilterChange}
                                />
                            </div>
                        </div>
                        <div className="flex-col w-full">
                            <label htmlFor="checkingStatus" className="gap-1 self-stretch w-full text-gray-900 text-base">
                                Submitted By User
                            </label>
                            <div className="flex gap-2.5 items-center px-4 py-2.5 mt-2.5 w-full whitespace-nowrap bg-white rounded-md border border-solid border-navBtn text-slate-400">
                                <select
                                    name="proposedBy"
                                    value={filters.proposedBy}
                                    onChange={handleFilterChange}
                                    className="flex-1 shrink self-stretch my-auto basis-0 bg-transparent border-none outline-none text-base"
                                >
                                    <option value="">Select User</option>
                                    {
                                        Array.isArray(users) &&
                                        users.map((user) => (
                                            <option key={user._id} value={user._id}>
                                                {user.username || user.companyName || user.ngoName}
                                            </option>
                                        ))
                                    }
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className='flex gap-3 w-full'>
                        <div className="flex-col w-full">
                            <label htmlFor="checkingStatus" className="gap-1 self-stretch w-full text-gray-900 text-base">
                                Status
                            </label>
                            <div className="flex gap-2.5 items-center px-4 py-2.5 mt-2.5 w-full whitespace-nowrap bg-white rounded-md border border-solid border-navBtn text-slate-400">
                                <select
                                    name="status"
                                    value={filters.status}
                                    onChange={handleFilterChange}
                                    className="flex-1 shrink self-stretch my-auto basis-0 bg-transparent border-none outline-none text-base"
                                >
                                    <option value="">All Status</option>
                                    <option value="active">Active</option>
                                    <option value="pending">Pending</option>
                                    <option value="approved">Approved</option>
                                    <option value="rejected">Rejected</option>
                                    <option value="inactive">Inactive</option>
                                </select>
                            </div>
                        </div>
                        <div className="flex-col w-full">
                            <label htmlFor="checkingStatus" className="gap-1 self-stretch w-full text-gray-900 text-base">
                                Blog Category
                            </label>
                            <div className="flex gap-2.5 items-center px-4 py-2.5 mt-2.5 w-full whitespace-nowrap bg-white rounded-md border border-solid border-navBtn text-slate-400">
                                <select
                                    name="category"
                                    value={filters.category}
                                    onChange={handleFilterChange}
                                    className="flex-1 shrink self-stretch my-auto basis-0 bg-transparent border-none outline-none text-base"
                                >
                                    <option value="">All Categories</option>
                                    {Array.isArray(challengeCategoryList) &&
                                        challengeCategoryList.map((category) => (
                                            <option key={category._id} value={category.name}>
                                                {category.name}
                                            </option>
                                        ))}
                                </select>
                            </div>
                        </div>
                        <div className="flex-col w-full">
                            <label htmlFor="checkingStatus" className="gap-1 self-stretch w-full text-gray-900 text-base">
                                Blog Title
                            </label>
                            <div className="flex gap-2.5 items-center px-4 py-2.5 mt-2.5 w-full whitespace-nowrap bg-white rounded-md border border-solid border-navBtn text-slate-400">
                                <input
                                    type="text"
                                    name="title"
                                    value={filters.title}
                                    onChange={handleFilterChange}
                                    placeholder="Enter Blog Title"
                                    className='outline-none focus:ring-0'
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className='flex gap-3 items-center justify-end p-5'>
                    <ActionButton
                        variant={'reset'}
                        text={'Reset'}
                        handleSubmit={handleReset}
                    />
                    <ActionButton
                        variant={'submit'}
                        text={'Search'}
                        handleSubmit={handleSearch}
                    />
                </div>
            </form>

            <section className="flex flex-col pt-5 w-full mt-5 bg-white rounded-md shadow-[0px_0px_25px_rgba(94,92,154,0.1)] max-md:max-w-full">
                <div className="flex flex-col pr-px pl-6 w-full max-md:pl-5 max-md:max-w-full">
                    <h1 className="self-start text-lg font-semibold">Blog Submissions</h1>
                    <UserBlogListTable
                        data={Array.isArray(filteredData) ? filteredData : (Array.isArray(data) ? data : [])}
                        toast={toast}
                    />
                </div>
            </section>
            <ToastContainer
                position="top-right"
                autoClose={3000}
            />
        </main>
    )
}

export default UserBlogList;